import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/app/(app)/academy/error.tsx");
